export default __webpack_public_path__ + "static/char-page-pic-01-4240a51c2dbb8680ee31e23f8dc8b31d.png";